import { styled, css } from 'styled-components';

import { FloatingLabelProps } from './types';

const TextWrapper = styled.div<FloatingLabelProps>`
  position: absolute;
  top: calc(50% - 0.5em);
  left: var(--spacing-4);
  line-height: 1em;
  transform-origin: bottom left;
  color: var(--color-numa-black--250);
  transition: var(--transition--short);

  ${({ isQuiet }) =>
    isQuiet &&
    css`
      left: 0;
    `}
  ${({ isActive }) =>
    isActive &&
    css`
      transform: scale(0.75) translateY(-1em);
    `}
`;

export const FloatingLabelWrapper = styled.label<FloatingLabelProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const FloatingLabel = ({ isActive, children, isQuiet, ...labelProps }: FloatingLabelProps) => (
  <FloatingLabelWrapper isQuiet={isQuiet} isActive={isActive} {...labelProps}>
    <TextWrapper isQuiet={isQuiet} isActive={isActive} data-active={isActive}>
      {children}
    </TextWrapper>
  </FloatingLabelWrapper>
);
export default FloatingLabel;
